import React, { createContext, useContext, useState, useEffect } from 'react';

export const translations = {
  it: {
    welcome: 'Benvenuto',
    bookNow: 'Prenota ora',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    nights: 'notti',
    night: 'notte',
    guests: 'ospiti',
    guest: 'ospite',
    services: 'Servizi',
    extras: 'Extra',
    guestInfo: 'Informazioni Ospite',
    fullName: 'Nome e Cognome',
    email: 'Email',
    phone: 'Telefono',
    numberOfGuests: 'Numero di ospiti',
    specialRequests: 'Richieste speciali',
    houseRules: 'Regole della casa',
    acceptRules: 'Ho letto e accetto le regole della casa',
    submit: 'Invia Richiesta',
    confirmationTitle: 'Richiesta Inviata',
    confirmationText: 'La Sua richiesta è stata ricevuta. Sarete contattati entro 24 ore.',
    contactConcierge: 'Contatta il Concierge',
    yourKey: 'La Tua Chiave',
    timeRemaining: 'Tempo rimanente',
    expiredTitle: 'Chiave Scaduta',
    expiredText: 'Il periodo di validità della chiave è terminato.',
    activityLog: 'Registro Accessi',
    noActivity: 'Nessuna attività registrata.',
    open: 'Apri',
    close: 'Chiudi',
    unlock: 'Sblocca',
    lock: 'Blocca',
    selectDates: 'Seleziona le date del soggiorno',
    minStay: 'Soggiorno minimo',
    noAvailability: 'Nessuna disponibilità',
    loading: 'Caricamento...',
    bookingReceived: 'Prenotazione ricevuta',
    total: 'Totale',
    subtotal: 'Subtotale',
    cityTax: 'Tassa di soggiorno',
    baseRate: 'Tariffa base',
    weekendSurcharge: 'Supplemento weekend',
    perNight: 'per notte',
    perPerson: 'per persona',
    perDay: 'per giorno',
    quantity: 'Quantità',
    download: 'Scarica',
    brochure: 'Brochure',
    days: 'giorni',
    day: 'giorno',
  },
  en: {
    welcome: 'Welcome',
    bookNow: 'Book now',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    nights: 'nights',
    night: 'night',
    guests: 'guests',
    guest: 'guest',
    services: 'Services',
    extras: 'Extras',
    guestInfo: 'Guest Information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    numberOfGuests: 'Number of guests',
    specialRequests: 'Special requests',
    houseRules: 'House Rules',
    acceptRules: 'I have read and accept the house rules',
    submit: 'Send Request',
    confirmationTitle: 'Request Sent',
    confirmationText: 'Your request has been received. You will be contacted within 24 hours.',
    contactConcierge: 'Contact Concierge',
    yourKey: 'Your Key',
    timeRemaining: 'Time remaining',
    expiredTitle: 'Key Expired',
    expiredText: 'The validity period of your key has ended.',
    activityLog: 'Activity Log',
    noActivity: 'No activity recorded.',
    open: 'Open',
    close: 'Close',
    unlock: 'Unlock',
    lock: 'Lock',
    selectDates: 'Select your stay dates',
    minStay: 'Minimum stay',
    noAvailability: 'No availability',
    loading: 'Loading...',
    bookingReceived: 'Booking received',
    total: 'Total',
    subtotal: 'Subtotal',
    cityTax: 'City tax',
    baseRate: 'Base rate',
    weekendSurcharge: 'Weekend surcharge',
    perNight: 'per night',
    perPerson: 'per person',
    perDay: 'per day',
    quantity: 'Quantity',
    download: 'Download',
    brochure: 'Brochure',
    days: 'days',
    day: 'day',
  }
};

const LanguageContext = createContext({ lang: 'it', t: (k) => k, setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('lang') || 'it');

  const setLang = (l) => {
    localStorage.setItem('lang', l);
    setLangState(l);
  };

  const t = (key) => translations[lang]?.[key] || translations.it?.[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, t, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
